import { useEffect, useState } from 'react'
import type { GapAnalysisViewDto } from '../API/rtk-query-api/store/tmsApi'
import { useGetGapAnalysisViewsQuery } from '../API/rtk-query-api/store/tmsApi'
import type { ErrorResponse } from '../redux/types/common'

export const useGapAnalysisViews = (fetchViews = true) => {
  const [views, setViews] = useState<Array<GapAnalysisViewDto>>([])
  const { data, isFetching, isLoading, refetch, isError, error } = useGetGapAnalysisViewsQuery(
    {},
    { skip: fetchViews === false }
  )

  useEffect(() => {
    if (data && !isFetching && !isLoading) {
      setViews(data.data ?? [])
    }
  }, [data, isFetching, isLoading])

  return { views: views, isFetching: isFetching || isLoading, refetch, isError, error: error as ErrorResponse }
}
